import { mapActions, mapGetters } from 'vuex';
import { Dialog } from 'vant';

export default {
  computed: {
    ...mapGetters(['companyInfo', 'webConfig', 'userInfo']),
  },
  methods: {
    ...mapActions(['getUserInfo', 'setRedirectUrl']),
    async checkAuth() {
      try {
        const userInfo = await this.getUserInfo()
        return Promise.resolve(userInfo)
      } catch (err) {
        if (err.code === 401) {
          this.$router.push({ name: 'login' })
          return Promise.reject()
        }
      }
    },
    personPublishAuth(type) {
      return new Promise((resolve, reject) => {
        if (!this.userInfo) {
          this.$router.push({ name: 'login' })
          return reject()
        } else if ((!this.webConfig.odd_jobs_personal_create_info && type === 'oddPosition') || (!this.webConfig.odd_jobs_personal_create_service && type === 'service')){
          this.$dialog.alert({
            title: '提示',
            message: `暂未开放！请联系客服 -- ${this.webConfig.kefu_tel || this.webConfig.kefu_mobile}`,
          });
          return reject()
        } else if (!this.userInfo.real_name_auth && this.webConfig.odd_jobs_need_real_name && type==='oddPosition') {
          Dialog.confirm({
            title: '提示',
            confirmButtonText: '去认证',
            confirmButtonColor: '#F13934',
            message: '发布零工需要完成实名认证',
          })
            .then(() => {
              this.setRedirectUrl(this.$route.fullPath)
              this.$router.push({ name: 'name-auth' })
            })
            .catch(() => { })
          return reject()
        } else {
          return resolve()
        }
      })
    },
    companyPublishAuth(type) {
      return new Promise((resolve, reject) => {
        //服务也根据后台配置开放开关
        if ((!this.webConfig.odd_jobs_create_info && type === 'oddPosition') || (!this.webConfig.odd_jobs_create_service && type === 'service')) {
          this.$dialog.alert({
            title: '提示',
            message: `暂未开放！请联系客服 -- ${this.webConfig.kefu_tel || this.webConfig.kefu_mobile}`,
          });
          return reject()
        }
        // const validateKeys = ['name', 'intro', 'contact_name', 'mobile', 'address', 'certificate_id']
        // const flag = validateKeys.findIndex(i => {
        //   return !this.companyInfo[i]
        // }) == -1
        if (!this.companyInfo.is_perfect) {
          Dialog.confirm({
            title: '提示',
            confirmButtonText: '去认证',
            confirmButtonColor: '#F13934',
            message: '您的企业信息尚未完善，请前往认证企业信息',
          })
            .then(() => {
              this.setRedirectUrl(this.$route.fullPath)
              this.$router.push({ name: 'companyInfo' })
            })
            .catch(() => { })
          return reject()
        } else if (this.companyInfo.is_perfect && (this.companyInfo.auth == 0 || this.companyInfo.auth == 3)) {
          Dialog.alert({
            title: '提示',
            message: '您企业信息尚未审核通过',
          })
          return reject()
        } else if (this.companyInfo.auth === 2) {
          Dialog.confirm({
            title: '提示',
            confirmButtonText: '去修改',
            confirmButtonColor: '#F13934',
            message: '您的企业信息审核不通过，请前往修改',
          })
            .then(() => {
              this.setRedirectUrl(this.$route.fullPath)
              this.$router.push({ name: 'companyInfo' })
            })
            .catch(() => { })
        } else if (this.companyInfo.auth) {
          return resolve()
        }
      })
    },
  },
}
